import { render, staticRenderFns } from "./InitTenantDialog.vue?vue&type=template&id=174b6241&scoped=true"
import script from "./InitTenantDialog.vue?vue&type=script&lang=js"
export * from "./InitTenantDialog.vue?vue&type=script&lang=js"
import style0 from "./InitTenantDialog.vue?vue&type=style&index=0&id=174b6241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174b6241",
  null
  
)

export default component.exports